import { filterToQueryParams } from '../../utils';
import { request } from '../../request';
import { FiltersCollection } from '@libs/store/filters';
import { RecurrenceShortListItem } from '@libs/models/shifts';

export async function getRecurrenceToShare(params: {
  filters?: FiltersCollection;
}): Promise<RecurrenceShortListItem[]> {
  const { filters = {} } = params;
  const applyFilters = filterToQueryParams(filters, {
    removeEmpty: true,
    renameMap: { statuses: 'status' },
  });
  const response = await request.get<RecurrenceToShare[]>('/v2/shift-recurrences/to-share', {
    params: {
      ...applyFilters,
    },
  });

  return response.data.map((recurrence) => ({
    ...recurrence,
    id: recurrence.id,
    status: recurrence.status as RecurrenceShortListItem['status'],
    qualifications:
      recurrence.staffNurseQualificationFilters &&
      recurrence.staffNurseQualificationFilters.map((qualification) => ({
        id: qualification.id || '',
        name: qualification.name || '',
        abbreviation: qualification.abbreviation || '',
        category: qualification.category || '',
      })),
    startDate: recurrence.startDate,
    endDate: recurrence.endDate,
    recurrence: recurrence.id.startsWith('shiftrotation-')
      ? 'rotation'
      : recurrence.id.startsWith('shiftseries-')
        ? 'series'
        : 'single',
  }));
}

type RecurrenceToShare = {
  id: string;
  status: 'Opened';
  agenciesForShare: {
    id: string; //'staffingpartner-00000000000000000000000000';
    logoURL: string;
    name: string;
    tenantId: string;
  }[];
  staffNurseQualificationFilters: [
    {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    },
  ];
  startDate: {
    dateTime: string;
    timeZone: string;
  };
  endDate: {
    dateTime: string;
    timeZone: string;
  };
};
